var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"parent",staticClass:"resizable-component",style:(_vm.style)},[_vm._t("default"),_vm._l((_vm.active),function(el){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.maximize),expression:"!maximize"}],key:el,class:'resizable-' + el})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }